import React from 'react';
import {
  Hidden, makeStyles, createMuiTheme, ThemeProvider,
} from '@material-ui/core';
import { Button } from 'rsuite';
import config from '@/configs/config';
import bbImage from './images/mobile_locationpartners_bb.png';
import dBbImage from './images/desktop_locationpartners_bb.png';
import featuresImage from './images/mobile_locationpartners_features.png';
import foodPicsImage from './images/mobile_locationpartners_food.png';
import dFoodPicsImage from './images/desktop_locationpartners_food.png';
import partnersLogosImage from './images/mobile_locationpartners_logos.png';
import dPartnersLogosImage from './images/desktop_locationpartners_logos.png';
import pricingImage from './images/mobile_locationpartners_options.png';
import PricingImageA from './images/pricingImageA.png';
import PricingImageB from './images/pricingImageB.png';
import defaultTheme from './defaultTheme';
import icon1 from './images/icon_1.png';
import icon2 from './images/icon_2.png';
import icon3 from './images/icon_3.png';
import icon4 from './images/icon_4.png';
import icon5 from './images/icon_5.png';
import icon6 from './images/icon_6.png';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    paddingBottom: theme.spacing(2),
  },
  bbContainer: {
    alignItems: 'center',
    backgroundImage: `url(${bbImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    display: 'flex',
    fontSize: 32,
    fontWeight: 'bold',
    height: 228,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      height: 661,
      backgroundImage: `url(${dBbImage})`,
    },
  },
  bbContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'start',
      width: '100%',
      fontSize: 62,
      height: 661,
      maxWidth: 768,
    },
  },
  bbButton: {
    background: theme.palette.primary.main,
    borderRadius: 4,
    color: 'black',
    fontSize: 14,
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 3),

    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
      marginTop: theme.spacing(3),
    },
  },
  bbDescription: {
    fontSize: 14,
    fontWeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
  content: {
    alignItems: 'center',
    color: '#4f4f4f',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 768,
      fontSize: 16,
    },
  },
  contentTitle: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  contentBody: {
    marginTop: 12,
    color: '#4f4f4f',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  contentImages: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: theme.spacing(5, 0),
    maxWidth: 768,

    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  foodPicsContainer: {
    height: 508,
    position: 'relative',
    width: '100%',
  },
  foodPics: {
    backgroundImage: `url(${foodPicsImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 508,
    padding: theme.spacing(3, 0),
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  foodPicsContent: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    fontWeight: 'bold',
    height: 350,
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-55%)',
    width: '100%',
  },
  planContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'bold',
    justifyContent: 'center',
    padding: theme.spacing(3, 0),
    width: '100%',
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      background: '#e9e9e9',
      paddingBottom: 0,
    },
  },
  planButtonContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  planButton: {
    background: '#00a115',
    borderRadius: 4,
    color: 'white',
    fontSize: 27,
    padding: theme.spacing(0.5, 3),
  },
  planHeader: {
    border: 0,
    borderBottomWidth: 3,
    borderColor: 'black',
    borderStyle: 'solid',
    borderTopWidth: 3,
    boxSizing: 'border-box',
    fontSize: 20,
    padding: theme.spacing(1),
  },
  planBody: {
    color: '#ffb120',
    fontSize: 42,
    fontWeight: 'bold',
    marginTop: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      alignItems: 'end',
      display: 'flex',
      fontSize: 60,
      marginTop: 0,
    },
  },
  planFooter: {
    fontSize: 35,

    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  brandsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  brandsHeader: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    fontSize: 40,
    fontWeight: 'bold',
    height: 92,
    justifyContent: 'center',
    width: '100%',
  },
  brandsBody: {
    padding: theme.spacing(3),
  },
  priceBg: {
    background: '#e9e9e9',
    bottom: 0,
    height: '15%',
    position: 'absolute',
    width: '100%',
  },
  featuresBg: {
    background: theme.palette.primary.main,
    height: '70%',
    position: 'absolute',
    width: '100%',
  },
  pricingContainer: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 768,
  },
  pricingImage: {
    width: '50%',
  },
  pricingImageImg: {
    width: '100%',
    height: 'auto',
  },
}));

export const Page = ({ formLink }) => {
  const classes = useStyle();

  console.log(formLink);

  return (
    <div className={classes.root}>
      <div className={classes.bbContainer}>
        <div className={classes.bbContent}>
          <span>人氣甜點飲料餐盒</span>
          <span>每日新鮮配送</span>
          <span className={classes.bbDescription}>公司福委會唯一指定</span>
          <Button
            className={classes.bbButton}
            target="_blank"
            href={formLink}
          >
            立即諮詢

          </Button>
        </div>
      </div>
      <div className={classes.content}>
        <span className={classes.contentTitle}>場域進駐方案</span>
        <div className={classes.contentBody}>
          <span>
            {config.BrandNameTW}
            是座落在城市中的迷你無人商店，為上班族帶來豐富的餐飲變化，解決上班族購餐方便性和吃膩的問題。
          </span>
          <span>每天都能享受不同的餐飲選擇及寶貴的休憩時刻，在忙碌的工作當中也能擁有真正屬於自己的自由時間。</span>
        </div>
        <Hidden xsDown>
          <div className={classes.contentImages}>
            <img src={icon1} alt="公司福利輕鬆使用,支援員工識別證感應扣款" />
            <img src={icon2} alt="每日新鮮配送,天天來點不一樣" />
            <img src={icon3} alt="超近能量補給,不用再煩惱要吃什麼" />
            <img src={icon4} alt="會員免運預定服務?,商品線上預定/機台自取" />
            <img src={icon5} alt="客製化優惠方案,依福委會補助套用折扣" />
            <img src={icon6} alt="無接觸購餐,自助購餐好安心" />
          </div>
        </Hidden>
        <Hidden smUp>
          <img src={featuresImage} alt="" width="100%" style={{ marginTop: 24 }} />
        </Hidden>
      </div>
      <Hidden xsDown>
        <div style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          marginTop: 24,
          position: 'relative',
          width: '100%',
        }}
        >
          <div className={classes.featuresBg} />
          <img
            src={dFoodPicsImage}
            alt="依需求提供豐富餐食服務,飲料、甜點、餐盒、零食及各式排隊美食應有盡有"
            width="100%"
            style={{ zIndex: 1, maxWidth: 768 }}
          />
          <div className={classes.priceBg} />
        </div>
      </Hidden>
      <Hidden smUp>
        <div className={classes.foodPicsContainer}>
          <div className={classes.foodPics} />
          <div className={classes.foodPicsContent}>
            <span style={{ fontSize: 30 }}>依需求提供豐富餐食服務</span>
            <span style={{ marginTop: 24, fontSize: 18 }}>
              飲料、甜點、餐盒、各式排隊美食
            </span>
            <span style={{ fontSize: 18 }}>
              應有盡有
            </span>
          </div>
        </div>
      </Hidden>
      <div className={classes.planContainer}>
        <span className={classes.planHeader}>合作方案</span>
        <div className={classes.planBody}>迷你無人商店</div>
        <span className={classes.planFooter}>上班族的救星</span>
        <div className={classes.planButtonContainer}>
          <Button
            className={classes.planButton}
            target="_blank"
            href={formLink}
          >
            請專人聯繫我

          </Button>
        </div>
        <Hidden xsDown>
          <div className={classes.pricingContainer}>
            <div className={classes.pricingImage}>
              <img src={PricingImageA} alt="A.免費進駐服務" className={classes.pricingImageImg} />
            </div>
            <div className={classes.pricingImage}>
              <img src={PricingImageB} alt="B.福委加值服務" className={classes.pricingImageImg} />
            </div>
          </div>
        </Hidden>
        <Hidden smUp>
          <img src={pricingImage} alt="" width="100%" style={{ marginTop: 16 }} />
        </Hidden>
      </div>
      <div className={classes.brandsContainer}>
        <span className={classes.brandsHeader}>進駐企業/場域</span>
        <div className={classes.brandsBody}>
          <Hidden xsDown>
            <img src={dPartnersLogosImage} alt="" width="100%" />
          </Hidden>
          <Hidden smUp>
            <img src={partnersLogosImage} alt="" width="100%" />
          </Hidden>
        </div>
      </div>
    </div>
  );
};

export default ({ formLink }) => {
  const theme = createMuiTheme(defaultTheme);

  return (
    <ThemeProvider theme={theme}>
      <Page formLink={formLink} />
    </ThemeProvider>
  );
};
